import enums from '@/helpers/enums.js';

function validateFloat(value) {
  const floatValue = parseFloat(value);

  return isNaN(floatValue)
    ? 0
    : floatValue;
}

function validateInt(value) {
  const intValue = parseInt(value);

  return isNaN(intValue)
    ? 0
    : intValue;
}

function round(number, decimals = 2) {
  return parseFloat(number.toFixed(decimals));
}

function roundMoneyIEEE754(number, decimals = 2) {
  if( !number ) return 0;
  const factor = Math.pow(10, decimals);
  const value = Number(number);
  return parseFloat((Math.round((value + Number.EPSILON) * factor) / factor).toFixed(decimals));
}

function percentToFloat (percentValue) {
  const result = percentValue / 100;
  return result;
}

function applyPercentDiscount (originalValue, percentDiscount) {
  let discount = percentToFloat(percentDiscount);

  let result = originalValue * (1 - discount);

  return result;
}

function applyFixedDiscount (originalValue, fixedDiscount) {
  let result = originalValue - fixedDiscount;

  return result;
}

function applyDiscount(originalValue, discount, discountType) {
  let result = originalValue;

  if (discountType === enums.DiscountType.PERCENTAGE) {
    result = applyPercentDiscount(result, discount);
  } else if (discountType === enums.DiscountType.FIXED) {
    result = applyFixedDiscount(result, discount);
  }

  return result;
}

function getTotalPeriods (periods, periodType) {
  if (periodType === enums.FinancingPeriodType.ANNUAL) {
    return periods * 12;
  } else {
    return periods;
  }
}

function pmt (rate, nper, pv, fv = 0, type = 0) {
  // If interest rate is zero, payment is principal + future value divided by number of periods
  if (rate === 0) return -(pv + fv) / nper;

  // Compound interest factor: (1 + rate) ^ number of periods
  const pvif = Math.pow(1 + rate, nper);

  // PMT formula: calculates payment amount based on rate, periods, present and future values
  let pmt = rate / (pvif - 1) * -(pv * pvif + fv);

  // Adjust payment if due at beginning of period (type=1)
  if (type === 1) pmt /= (1 + rate);

  return pmt; // Return payment amount (typically negative as cash outflow)
}

function getPeriodRate(rate, periodType) {
  let value = rate;

  if (periodType === enums.FinancingPeriodType.ANNUAL) {
    value = rate / 12;
  }

  return value;
}

function calculateInstallment (netAmount, periods, rate) {
  const result = {
    total: 0.0,
    base: 0.0,
    interest: 0.0,
  };
  
  if (periods <= 0) {
    result.total = netAmount;
  } else {
    const pv = Math.abs(netAmount) * -1;

    result.total = pmt(rate, periods, pv);
  }

  result.interest = netAmount * rate;
  
  result.base = result.total - result.interest;

  return result;
}

export default {
  parseFloat: validateFloat,
  parseInt: validateInt,
  percentToFloat,
  round,
  roundMoneyIEEE754,
  applyPercentDiscount,
  applyFixedDiscount,
  applyDiscount,
  getTotalPeriods,
  getPeriodRate,
  pmt,
  calculateInstallment,
}